import PropTypes from "prop-types";
import React from "react";
import ReactPlayer from "react-player";
import checkScreenLayout from "../shared/utils/checkScreenLayout";
import VimeoPlayer from "../shared/vimeo/VimeoPlayer";
import YouTubePlayer from "../shared/youtube/YouTubePlayer";
import MediaAlbum from "./MediaAlbum.jsx";
import MediaEvent from "./MediaEvent.jsx";
import MediaLifeEvent from "./MediaLifeEvent.jsx";
import MediaMultiShare from "./MediaMultiShare.jsx";
import MediaPhoto from "./MediaPhoto.jsx";
import MediaShare from "./MediaShare.jsx";
import ProfileCard from "./ProfileCard.jsx";

const MAX_TIME_FOR_VIDEO_LOAD = 10000;

class FacebookSlideshow extends React.Component {
  videoLoadTimeout; // setTimeout ref for checking video start.

  constructor(props) {
    super(props);
    this.state = {
      player: null
    };
  }

  componentWillUnmount() {
    if (this.durationTimeout) {
      clearTimeout(this.durationTimeout);
      this.durationTimeout = null;
    }
  }

  onFeedItemShowEnd() {
    console.log("FacebookSlideshow: onFeedItemShowEnd");
    if (this.durationTimeout) {
      clearTimeout(this.durationTimeout);
      this.durationTimeout = null;
    }
    if (this.props.onSlideEnded) {
      this.props.onSlideEnded();
    }
  }

  playVideo() {
    let { player } = this.state;
    if (player) {
      player.play();
      this.props.mute ? player.mute() : player.unmute();
    }
  }

  /**
   * Triggered if a video fails to play.
   * Log and then move to next slide.
   */
  onVideoError = e => {
    console.warn("Video playback error", e);
    this.onFeedItemShowEnd();
  };

  /**
   * Triggered when a video ends successfully.
   */
  onVideoEnded = () => {
    this.onFeedItemShowEnd();
  };

  // APPS-1263: Videos may not report errors (e.g. embedding blocked by permissions)
  // Timeout workaround to move to next slide if a video does not start.
  startVideoLoadTimeout = () => {
    this.videoLoadTimeout = setTimeout(() => {
      this.onVideoError("Video did not begin on time.");
    }, MAX_TIME_FOR_VIDEO_LOAD);
  };

  /**
   * Clear any saved timeout (so that it does not skip future slides too)
   */
  clearVideoLoadTimeout = () => {
    if (this.videoLoadTimeout) {
      clearTimeout(this.videoLoadTimeout);
      this.videoLoadTimeout = undefined;
    }
  };

  render() {
    let like = this.props.like;
    let post = this.props.data;
    let postMedia = "";
    let postMessage = post.message;
    let postMessageClassname = "";
    let self = this;

    this.clearVideoLoadTimeout();

    if (postMessage != null) {
      document.body.classList.remove("no-message");

      if (
        checkScreenLayout.getLayout() === "square" ||
        checkScreenLayout.getLayout() === "portrait"
      ) {
        postMessage = postMessage.slice(0, 150) + "...";
        postMessageClassname = "text-small";
      } else if (postMessage.length > 500) {
        postMessage = postMessage.slice(0, 350) + "...";
        postMessageClassname = "text-small";
      } else if (postMessage.length < 200) {
        postMessageClassname = "text-large";
      } else if (postMessage.length < 250) {
        postMessageClassname = "text-medium";
      }

      postMessageClassname = postMessageClassname + " color-text-body";
    } else {
      document.body.classList.add("no-message");
    }

    let bgStyle = {};

    if (like !== undefined) {
      like = this.props.like;
      bgStyle = { backgroundImage: "none" };

      if (like.cover && like.cover.source) {
        bgStyle = {
          backgroundImage: "url(" + like.cover.source + ")"
        };
      }
    }

    let mediaType = "";

    if (
      post.attachments !== "undefined" &&
      post.attachments !== undefined &&
      post.attachments
    ) {
      let attachments = post.attachments.data;

      attachments.forEach(attachment => {
        mediaType = attachment.type;

        console.log("MEDIA TYPE: ", mediaType);

        document.body.className = "";
        document.body.classList.add(mediaType);

        // if content is Youtube but thei player lib not loaded yet, so skip it
        if (mediaType === "video_share_youtube" && !window.YT) {
          mediaType = "";
        }

        let fbUrl, redirectUrl, cleanFbRedirectUrl, origImgSrc, subattachments;

        switch (mediaType) {
          case "animated_image_share":
            origImgSrc = decodeURIComponent(
              attachment.media.image.src.match(/(url=)([^&]+)/)[2]
            );
            postMedia = (
              <MediaPhoto
                media={origImgSrc}
                post={post}
                color={this.props.color}
                bgcolor={this.props.bgcolor}
              />
            );
            break;
          case "new_album":
          case "album":
            if (postMessage.length > 150) {
              postMessage = postMessage.slice(0, 150) + "...";
            }
            postMessageClassname = "text-medium";
            subattachments = attachment.subattachments.data;

            postMedia = (
              <MediaAlbum
                media={subattachments}
                post={post}
                color={this.props.color}
                bgcolor={this.props.bgcolor}
                preload={this.props.preload}
              />
            );
            break;
          case "life_event":
            postMedia = (
              <MediaLifeEvent
                data={attachment}
                color={this.props.color}
                bgcolor={this.props.bgcolor}
                preload={this.props.preload}
              />
            );
            break;
          case "square_image_share":
          case "image_share":
          case "photo":
          case "cover_photo":
          case "live_event":
            postMedia = (
              <MediaPhoto
                media={attachment.media.image.src}
                post={post}
                color={this.props.color}
                bgcolor={this.props.bgcolor}
              />
            );
            break;
          case "video_share_highlighted":
            // IMPORTANT - Facebook potentially never sends this value anymore?
            fbUrl = attachment.url.split("?u=");
            redirectUrl = fbUrl[1].split("&h");
            cleanFbRedirectUrl = decodeURIComponent(redirectUrl[0]);
            postMedia = (
              <VimeoPlayer
                url={cleanFbRedirectUrl}
                onPlayEnded={this.onVideoEnded}
                max_play_durations={this.props.max_play_durations}
                mute={this.props.mute}
              />
            );
            break;
          case "video_inline":
          case "video_direct_response":
            this.startVideoLoadTimeout();
            postMedia = (
              <ReactPlayer
                url={attachment.url}
                config={{
                  facebook: {
                    appId: "1116420758419937"
                  }
                }}
                playing={true}
                volume={this.props.mute ? 0 : 1}
                muted={this.props.mute}
                controls={false}
                width="100%"
                height="100%"
                onReady={() => {
                  this.clearVideoLoadTimeout();
                }}
                onEnded={this.onVideoEnded}
                onError={this.onVideoError}
              />
            );
            break;
          case "video_share_youtube":
            // IMPORTANT - Facebook potentially never sends this value anymore?
            postMedia = (
              <YouTubePlayer
                url={attachment.url}
                isStandAlone={false}
                onPlayEnded={this.onVideoEnded}
                max_play_durations={this.props.max_play_durations}
                preload={this.props.preload}
                mute={this.props.mute}
              />
            );
            break;
          case "share":
            if (attachment.url.indexOf("www.facebook.com") <= -1) {
              fbUrl = attachment.url.split("?u=");
              redirectUrl = fbUrl[1].split("&h");
              cleanFbRedirectUrl = decodeURIComponent(redirectUrl[0]);
            }

            postMedia = (
              <div className="slide-wrapper">
                <div className="back-slide" />
                <div className="back-slide" />
                <MediaShare
                  title={attachment.title}
                  description={attachment.description}
                  image={attachment.media ? attachment.media.image.src : ""}
                  link={cleanFbRedirectUrl}
                  post={post}
                  bgcolor={this.props.bgcolor}
                  color={this.props.color}
                  preload={this.props.preload}
                  displayQr={this.props.displayQr}
                />
              </div>
            );
            break;
          case "event":
            postMedia = (
              <div className="slide-wrapper">
                <div className="back-slide" />
                <div className="back-slide" />
                <MediaEvent
                  title={attachment.title}
                  description={attachment.description}
                  image={attachment.media.image.src}
                  link={attachment.target.url}
                  id={attachment.target.id}
                  facebook_access={this.props.facebook_access}
                  post={post}
                  bgcolor={this.props.bgcolor}
                  color={this.props.color}
                  preload={this.props.preload}
                  displayQr={this.props.displayQr}
                />
              </div>
            );
            break;
          case "multi_share":
            subattachments = attachment.subattachments.data;
            postMedia = (
              <MediaMultiShare
                media={subattachments}
                post={post}
                bgcolor={this.props.bgcolor}
                color={this.props.color}
                preload={this.props.preload}
                displayQr={this.props.displayQr}
              />
            );
            break;

          default:
            // Skip media
            console.log("Skip video for mediaType = " + mediaType);
            postMedia = "";
            setTimeout(() => {
              console.log("send show end");
              self.onFeedItemShowEnd();
            }, 40);
            return <div />;
        }
      });
    } else {
      document.body.className = "";
      document.body.classList.add("text");
    }

    if (mediaType.indexOf("video") > -1) {
      // video player response for callback when playend
    } else {
      if (this.durationTimeout) {
        clearTimeout(this.durationTimeout);
        this.durationTimeout = null;
      }

      // during preload will not auto play next item
      if (this.props.preload === false) {
        this.durationTimeout = setTimeout(
          () => this.onFeedItemShowEnd(),
          this.props.duration
        );
      }
    }

    if (like !== undefined) {
      like = this.props.like;

      bgStyle = { backgroundImage: "none" };

      if (like.cover && like.cover.source) {
        bgStyle = {
          backgroundImage: "url(" + like.cover.source + ")"
        };
      }
    }

    let postClassname = "slide " + mediaType;

    if (this.props.preload === true) {
      postClassname += " preloadState";

      return (
        <div key={post.guid} className={postClassname}>
          <div className="post-likes">
            <div className="icon-like" />
            {post.likes != null && <p>{post.likes.summary.total_count}</p>}
          </div>

          <div className="slide-content preloadState">{postMedia}</div>
        </div>
      );
    }

    return (
      <div key={post.guid} className={postClassname}>
        <div className="slide-content animated fadeIn">
          <div className="fb-icon" />

          <div className="content" style={bgStyle}>
            <ProfileCard
              profilePic={this.props.profilePic}
              name={this.props.name}
              time={post.created_time}
              theme={this.props.theme}
              link={this.props.pageLikesInfo.link}
            />
            <div className="animated fadeInUp font-body">
              <h1 className={postMessageClassname}>{postMessage}</h1>
            </div>

            <div className="post-likes animated fadeInUp">
              <div className="icon-like" />
              {post.likes != null && <p>{post.likes.summary.total_count}</p>}
            </div>
          </div>

          <div className="media animated fadeIn" style={bgStyle}>
            {postMedia}
          </div>
        </div>
      </div>
    );
  }
}

FacebookSlideshow.propTypes = {
  key: PropTypes.string,
  data: PropTypes.shape({
    attachments: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          media: PropTypes.shape({
            image: PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
              src: PropTypes.string
            })
          }),
          target: PropTypes.shape({
            url: PropTypes.string
          }),
          title: PropTypes.string,
          type: PropTypes.string,
          url: PropTypes.string
        })
      )
    }),
    created_time: PropTypes.string,
    id: PropTypes.string,
    likes: PropTypes.shape({
      data: PropTypes.array,
      summary: PropTypes.object
    }),
    link: PropTypes.string,
    message: PropTypes.string
  }),
  pageLikesInfo: PropTypes.object,
  profilePic: PropTypes.string,
  name: PropTypes.string,
  duration: PropTypes.number,
  onSlideEnded: PropTypes.func,
  max_play_durations: PropTypes.number,
  color: PropTypes.string,
  bgcolor: PropTypes.string,
  facebook_access: PropTypes.string,
  fullscreen: PropTypes.string,
  preload: PropTypes.bool,
  theme: PropTypes.string,
  displayQr: PropTypes.bool,
  mute: PropTypes.bool,
  like: PropTypes.object
};

export default FacebookSlideshow;
